import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import Slider from 'react-slick';
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from "../../CommonUI/Pagination/Pagination";
import { Portal } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Vortex } from 'react-loader-spinner'
let companyInformation;

function Ipowatch() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { BaseURL } = useContext(URLstateContext);
    const [data, setData] = useState([]);
    const [dataLoose, setDataLoose] = useState([]);
    const [dataIndex, setDataIndex] = useState([]);
    const [dataNews, setDataNews] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [dataActive, setDataActive] = useState([]);
    const [dataCap, setDataCap] = useState([]);
    const [dataTicker, setDataTicker] = useState([]);
    const [dataDraft, setDataDraft] = useState([]);
    const [dataDraft2, setDataDraft2] = useState([]);
    const [groupValue, setGroupValue] = useState("sno");
    const [dataBest, setDataBest] = useState([]);
    const [dataNew, setDataNew] = useState([]);
    const [dataIpo, setDataIpo] = useState([]);
    const [dataWatch, setDataWatch] = useState([]);
    const [dataOpen, setDataOpen] = useState([]);
    const [dataClose, setDataClose] = useState([]);
    const [dataBasis, setDataBasis] = useState([]);
    const [dataIssue, setDataIssue] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [dataPer, setDataPer] = useState([]);
    const [fetchIdNews, setFetchIdNews] = useState([]);
    const [filteredNewsData, setFilteredNewsData] = useState([]);
    const [companyInfo, setCompanyInfo] = useState([]);
    const [dataaa, setDataaa] = useState([]);
    const [Snonumber, setSnonumber] = useState();
    const [loadingshow, setloadingshow] = useState(false);
    // const [groupValue, setValueBtn] = useState("sebi");
    const [type, settype] = useState(['sebi']);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let getData, getDataLoose, getDataIndex, getDataTicker, fetchId,
        getDataActive, getDataNews, getDataCap, getDataBest, getDataDraft, getDataDraft2, getDataNew, getDataIpo, getDataWatch, getDataOpen, getDataClose, getDataBasis, getDataIssue, getDataaa, getDataList, getDataPer;
    let navigate = useNavigate();
    let PageSize = 5;

    useEffect(() => {
        setloadingshow(true);
        const getUrlWatch = BaseURL + "Forthcoming";
        fetch(`${getUrlWatch}/1/8/-/-/-/-`)
            .then((response) => response.json())
            .then((dataW) => {
                getDataWatch = dataW.data;
                setDataWatch(getDataWatch);
                setloadingshow(false);
                //console.log(getDataWatch, "getDataWatch")
            })
            .catch((error) => {
            });


        // const getUrlOpen = BaseURL + "Forthcoming";
        fetch(`${getUrlWatch}/2/8/-/-/-/-`)
            .then((response) => response.json())
            .then((dataO) => {
                getDataOpen = dataO.data;
                setDataOpen(getDataOpen);
                setloadingshow(false);
                // console.log(getDataOpen, "getDataOpen")
            })
            .catch((error) => {
            });


        // const getUrlClose = BaseURL + "Forthcoming";
        fetch(`${getUrlWatch}/3/8/-/-/-/-`)
            .then((response) => response.json())
            .then((dataC) => {
                getDataClose = dataC.data;
                setDataClose(getDataClose);
                setloadingshow(false);
                //  console.log(getDataClose, "getDataClose")
            })
            .catch((error) => {
            });

    }, [type, groupValue]);

    const moreContent = () => {
        navigate("/IPO/Forthcoming-IPO")
    }

    return (
        <>
            <div className='market-inner-common ipo-head'>
                <div className='market-header'>
                    <h4>IPO Watch</h4>
                    <span className="moreContent" onClick={moreContent}>See More</span>
                </div>
                <Container className="add-border table-box">
                    <div className='ipo-common mf-common'>
                        <Tabs defaultActiveKey="upcoming" transition={true}>
                            <Tab eventKey="upcoming" title="Upcoming IPO">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-left'>Issue Type</th>
                                                <th className='text-right'>Issue Size(&#8377;)Cr</th>
                                                <th className='text-right'>Open Date</th>
                                                <th className='text-right'>Closed Date</th>
                                                <th className='text-right'>Offer Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        {(dataWatch === null) ? <h3 className="errormsg">No Data Found !!!</h3> : ''}
                                        <tbody>
                                            {(dataWatch != null) && dataWatch.map(
                                                ({ LNAME, IssueType, IssueSize, OPENDATE, CLOSDATE, ISSUEPRICE }) => (
                                                    <tr>
                                                        <td className="text-left">{LNAME} </td>
                                                        <td className="text-left">{IssueType} </td>
                                                        <td className="text-right">{IssueSize} </td>
                                                        <td className="text-right"> {(OPENDATE != null) ? OPENDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(CLOSDATE != null) ? CLOSDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(ISSUEPRICE != null) ? ISSUEPRICE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                            </Tab>
                            <Tab eventKey="open" title="Open IPO">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-left'>Issue Type</th>
                                                <th className='text-right'>Issue Size(&#8377;)Cr</th>
                                                <th className='text-right'>Open Date</th>
                                                <th className='text-right'>Closed Date</th>
                                                <th className='text-right'>Offer Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        {(dataOpen === null) ? <h3 className="errormsg">No Data Found !!!</h3> : ''}
                                        <tbody>
                                            {(dataOpen != null) && dataOpen.map(
                                                ({ lname, ISSUETYPE, IssueSize, OPENDATE, CLOSDATE, ISSUEPRICE }) => (
                                                    <tr>
                                                        <td className="text-left">{lname} </td>
                                                        <td className="text-left">{ISSUETYPE} </td>
                                                        <td className="text-right">{IssueSize} </td>
                                                        <td className="text-right"> {(OPENDATE != null) ? OPENDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(CLOSDATE != null) ? CLOSDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(ISSUEPRICE != null) ? ISSUEPRICE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                            </Tab>
                            <Tab eventKey="closed" title="Closed IPO">
                                <div className='mf-table table-responsive gainer-table'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left'>Company Name</th>
                                                <th className='text-left'>Issue Type</th>
                                                <th className='text-right'>Issue Size(&#8377;)Cr</th>
                                                <th className='text-right'>Open Date</th>
                                                <th className='text-right'>Closed Date</th>
                                                <th className='text-right'>Offer Price(&#8377;)</th>
                                            </tr>
                                        </thead>
                                        {(dataClose === null) ? <h3 className="errormsg">No Data Found !!!</h3> : ''}
                                        <tbody>
                                            {(dataClose != null) && dataClose.map(
                                                ({ Lname, IssueType, IssueSize, OPENDATE, CLOSDATE, ISSUEPRICE }) => (
                                                    <tr>
                                                        <td className="text-left">{Lname} </td>
                                                        <td className="text-left">{IssueType} </td>
                                                        <td className="text-right">{IssueSize} </td>
                                                        <td className="text-right"> {(OPENDATE != null) ? OPENDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(CLOSDATE != null) ? CLOSDATE.split('T')[0] : 0}</td>
                                                        <td className="text-right"> {(ISSUEPRICE != null) ? ISSUEPRICE.toFixed(2) : 0}</td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </Container>
            </div>
        </>
    );
}

export default Ipowatch;